import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IGrowthRecord } from './interface'
import { APIResponse } from '../../../services/interface'
import { ApiGet } from '../../../services/Service'
import { StatusEnum } from '../../type'

export interface GrowthState {
  growthRecord: IGrowthRecord[]
  selectedRange: any
  chosenStudio: { value: string; label: string }
  growthRecordStatus: StatusEnum
  namedGrowthFilters: {
    utmSource: string[]
    utmMedium: string[]
    utmCampaign: string[]
    utmContent: string[]
    utmMarket: string[]
    loc: string[]
  }
  error: any
}

const initialState: GrowthState = {
  growthRecord: [],
  selectedRange: null,
  chosenStudio: { value: '', label: '' },
  growthRecordStatus: StatusEnum.Idle,
  namedGrowthFilters: {
    utmSource: [],
    utmMedium: [],
    utmCampaign: [],
    utmContent: [],
    utmMarket: [],
    loc: [],
  },
  error: null,
}

export const getGrowthRecordAsync = createAsyncThunk(
  'patient/getGrowthRecordAsync',
  async (
    {
      startDate,
      endDate,
      source,
      medium,
      campaign,
      market,
      location,
      orgSource,
    }: {
      startDate: string
      endDate: string
      source?: string
      medium?: string
      campaign?: string
      market?: string
      location?: string
      orgSource?: boolean
    },
    thunkAPI,
  ) => {
    const url = `/metrics/v1/growth?startDate=${startDate}&endDate=${endDate}`

    let qs = ``

    if (source) {
      qs += `&source=${source}`
    }
    if (medium) {
      qs += `&medium=${medium}`
    }
    if (campaign) {
      qs += `&campaign=${campaign}`
    }
    if (market) {
      qs += `&market=${market}`
    }
    if (location) {
      qs += `&location=${location}`
    }
    if (orgSource) {
      qs += `&orgSource=true`
    }

    const response: APIResponse = await ApiGet(url + qs)
      .then((res) => res)
      .catch((err) => err)
    console.log(response.data.data, 'total response')

    if (!response.status) {
      return thunkAPI.rejectWithValue('Network error. Please check your internet.')
    } else if (response.data && response.data.code === 'success') {
      return thunkAPI.fulfillWithValue({
        data: response.data.data,
      })
    } else {
      return thunkAPI.rejectWithValue('Network error. Please check your internet.')
    }
  },
)

export const getNamedGrowthFiltersAsync = createAsyncThunk('studio/getNamedGrowthFiltersAsync', async (_, thunkAPI) => {
  const response: APIResponse = await ApiGet(`/metrics/v1/growth/filters`)
    .then((res) => res)
    .catch((err) => err)

  if (!response.status) {
    return thunkAPI.rejectWithValue('Network error. Please check your internet.')
  } else if (response.data && response.data.code === 'success') {
    return thunkAPI.fulfillWithValue({
      data: response.data.data,
    })
  } else {
    return thunkAPI.rejectWithValue('Network error. Please check your internet.')
  }
})

export const growthSlice = createSlice({
  name: 'growth',
  initialState,
  reducers: {
    setSelectedRange: (state, action) => {
      state.selectedRange = action.payload
    },
    setChosenStudio: (state, action) => {
      state.chosenStudio = action.payload
    },
    resetChosenStudio: (state) => {
      state.chosenStudio = { value: '', label: '' }
    },
  },
  extraReducers(builder) {
    //getGrowthRecord
    builder.addCase(getGrowthRecordAsync.pending, (state) => {
      state.growthRecordStatus = StatusEnum.Pending
    })
    builder.addCase(getGrowthRecordAsync.fulfilled, (state, action) => {
      state.growthRecord = action.payload.data
      state.growthRecordStatus = StatusEnum.Success
      state.error = action.payload
    })
    builder.addCase(getGrowthRecordAsync.rejected, (state) => {
      state.growthRecordStatus = StatusEnum.Failed
    })
    builder.addCase(getNamedGrowthFiltersAsync.fulfilled, (state, action) => {
      state.namedGrowthFilters = action.payload.data
    })
    builder.addCase(getNamedGrowthFiltersAsync.rejected, (state) => {})
  },
})

export default growthSlice.reducer

export const { setSelectedRange, setChosenStudio, resetChosenStudio } = growthSlice.actions
